<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.actionnaires"
      add-new-text="Ajouter un actionnaire/associé"
      :live="{ endpoint: 'sas-ajout-actionnaire', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      hidePoints
    >
      <template v-slot:show-mode="{ item }">
        <div v-if="item.actionnaire">
          <h3>{{ item.actionnaire.fullName }}</h3>
          <p>{{ item.actionnaire.licenseNumber }}</p>
        </div>
      </template>
      <template v-slot:edit-mode="{ item }">
        <SearchActionnaire
          v-if="!item.actionnaire"
          @pharmacien-selected="pharmacienSelected(item, $event)"
          :idToExclude="sas.actionnaires.filter((x) => x.actionnaire).map((x) => x.actionnaire.id)"
        >
        </SearchActionnaire>
        <div v-if="item.actionnaire">
          <h3>{{ item.actionnaire.fullName }}</h3>
          <p>{{ item.actionnaire.licenseNumber }}</p>
        </div>
        <v-checkbox
          class="list_counter_validator my-2 ml-6 p-0"
          :input-value="!!item.actionnaire"
          :rules="[() => !!item.actionnaire || 'Veuillez sélectionner un actionnaire']"
        ></v-checkbox>
      </template>
    </data-iterator>
    <CatalogueLive
      code="actionnaire_repondant"
      :items="
        sas.actionnaires
          ?.filter((a) => a.actionnaire !== null && a.actionnaire.id !== sasSociete.repondantSubstitut)
          .map(getTextSasActionnaireDropdown)
      "
      v-model="sas.sasSociete.repondant"
      :live="{ endpoint: 'sas-societe', cle: 25924, fileId: sas.sasSociete.id }"
    />
    <CatalogueLive
      code="actionnaire_substitut"
      :items="sas.actionnaires?.filter((a) => a.actionnaire !== null && a.actionnaire.id !== sasSociete.repondant).map(getTextSasActionnaireDropdown)"
      v-model="sas.sasSociete.repondantSubstitut"
      :live="{ endpoint: 'sas-societe', cle: 25925, fileId: sas.sasSociete.id }"
      :opq-if="this.sas.actionnaires.length > 1"
    />
    <FileInput
      code="convention_actionnaires"
      :file="sasSociete.conventionActionnaire"
      :live="liveSociete(25926)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opq-if="conditionConvention"
    />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import { Queue, Api } from "@/plugins/api"
import SearchActionnaire from "./component/SearchActionnaire.vue"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  components: { SearchActionnaire },
  props: {
    sas: { type: Object }
  },
  methods: {
    pharmacienSelected(item, pharmacien) {
      Queue.enqueue(() =>
        Api.post("sas-ajout-actionnaire", {
          fileId: item.id,
          cle: "200",
          value: pharmacien.id
        }).then(() => {
          item.actionnaire = pharmacien
        })
      )
    },
    liveSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    liveSasAjoutActionnaire(cle, item) {
      return { endpoint: "sas-ajout-actionnaire", cle: cle, fileId: item.id }
    },
    getTextSasActionnaireDropdown(sasActionnaire) {
      const value = sasActionnaire.actionnaire.id
      let text = sasActionnaire.actionnaire.fullName + " " + sasActionnaire.actionnaire.licenseNumber || "Veuillez sélectionner un actionnaire"
      return { value, text }
    }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionConvention() {
      return this.sas.actionnaires.length > 1 && this.getCatalogueCodeById("328", this.sas.sasSociete.formeJuridique) === "SPA"
    }
  }
}
</script>

<style></style>